if (isBrowser) {
    $(document).ready(function () {
        $('.pixel-check').on('click', function () {
            $('body').toggleClass('pixel-check-active');
        });


// var mySwiper = document.querySelector('.swiper-container').swiper

// $(".swiper-container").mouseenter(function() {
//   mySwiper.autoplay.stop();
//   console.log('slider stopped');
// });
// $(".swiper-container").mouseleave(function() {
//   mySwiper.autoplay.start();
//   console.log('slider started again');
// });


// menu dropdown
        $(".language-opener").on("click", function () {
            $('.language-dropdown').toggleClass("show");
        });
        $(".fractional-opener").on("click", function () {
            $('.fractional-dropdown').toggleClass("show");
        });
        $("html").click(function (e) {
            if ($(e.target).closest('.language-dropdown').length == 0)
                $(".language-dropdown").removeClass('show');
        });
        $("html").click(function (e) {
            if ($(e.target).closest('.fractional-dropdown').length == 0)
                $(".fractional-dropdown").removeClass('show');
        });


//

// $(document).ready(function() {
//   //login
//   $('.ico-sec').click(function() {
//     alert('s');
//       $('#signin-wrap').toggleClass('show-pass');
//       if ($('#signin-password').attr('type') == 'password') {
//           $('#signin-password').attr('type', 'text');
//       } else {
//           $('#signin-password').attr('type', 'password');
//       }
//   });
// });

        $("body").on("click", '.ico-pass', function (e) {
            $('.wrap1').toggleClass('show-pass');
            if ($('#signin-password').attr('type') == 'password') {
                $('#signin-password').attr('type', 'text');
            } else {
                $('#signin-password').attr('type', 'password');
            }
        });

        $("body").on("click", '.con-pass', function (e) {
            $('.wrap2').toggleClass('show-pass');
            if ($('#conform-password').attr('type') == 'password') {
                $('#conform-password').attr('type', 'text');
            } else {
                $('#conform-password').attr('type', 'password');
            }
        });

        $("body").on("click", '.mg-pass', function (e) {

            $('.wrap4').toggleClass('show-pass');
            if ($('#signin-password2').attr('type') == 'password') {
                $('#signin-password2').attr('type', 'text');
            } else {
                $('#signin-password2').attr('type', 'password');
            }
        });

        $("body").on("click", '.em-pass', function (e) {


            $('.wrap3').toggleClass('show-pass');
            if ($('#signin-password').attr('type') == 'password') {
                $('#signin-password').attr('type', 'text');
            } else {
                $('#signin-password').attr('type', 'password');
            }
        });

//
        $(".navbar-toggler").click(function () {
            $(".navbar-toggler").toggleClass("open");
        });

// btn
        if ($('.datepicker').length) {
            $(function () {
                $(".datepicker").datepicker();
            });
        }

        if ($('.multi-datepicker').length) {
            $(function () {
                $(".multi-datepicker").datepicker({
                    numberOfMonths: 2,
                    showButtonPanel: true
                });
            });
        }


// dropdown


        $("html").click(function (e) {
            if ($(e.target).closest('.shift-dropmenu').length == 0)
                $(".shift-dropmenu").removeClass('show');
        });
        /*$('.add-shift-btn-cus').on('click', function () {
            alert('dd');
            $('td .shift-dropmenu-add').removeClass('show');
           $(this).parent('.shiftDropdownCus .shift-dropmenu-add').addClass('show');
        });*/

// On off btn
        function activeMe(activeBtn) {

            var deactivateBtn = "";

            if (activeBtn == "yes") {
                deactivateBtn = "no";
            } else {
                deactivateBtn = "yes"
            }

            $('#' + deactivateBtn).removeClass('btn-primary');
            $('#' + activeBtn).addClass('btn-primary');

        }
    });
}


$('.shiftdrop-list li a').on('click', function() {

    var x =$(this).text(); // get text of selected li
    $('.shiftdrop-list li').removeClass('active');
    $(this).parent().addClass('active');
    $(".shift-opener").text(x); // assign text to main anchor tag

});
